import flyio from "flyio";
import {toLogin} from './api';
export async function HTTP(url,method='get',param={}) {
    switch (method) {
        case "get":
            if (param != {}) {
                let p = "";
                for (let key in param) {
                    if (p != "") {
                        p += "&";
                    }
                    p += key + "=" + param[key];
                }
                url += "?" + p;
            }
            param = {};
            break;
        case "post":
            break;
        case "delete":
            param["_method"] = "DELETE";
            method = "post";
            break;
        case "put":
            param["_method"] = "PUT";
            method = "post";
            break;
        case "option":
            param["_method"] = "OPTION";
            method = "post";
            break;
    }

    flyio.config.baseURL = process.env.VUE_APP_API_URL;
    //添加请求拦截器
    flyio.interceptors.request.use((request) => {
        request.headers = {
            Authorization: 'Bearer ' + window.localStorage.app_review_token,
        };
        return request;
    });
    
     //相应拦截器
     flyio.interceptors.response.use((response) => {
        return response.data;
    });
    try{
        let res = await flyio.request(url, param, {method: method,timeout: 100000})
        // console.log('api request callback info ',res)

        if(res.code === 401 || res.code === 403){
            console.log(url)
            toLogin()
        }
        return res
    }catch(e){
        if(e.status === 401){
            toLogin()
        }
        console.error('http error',e)
        return {
            code: 500,
            message: e,
            data:{}
        }
    }
}
 